export const Sizes = {
    S: 'S',
    M: 'M',
    L: 'L',
};

export const RadioButtonAccents = {
    Blue: 'blue',
};
